bz_app.directive('headerThumbnail', [
  'googleMapsStreetViewService',
  function (googleMapsStreetViewService) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        latitude: '@',
        longitude: '@',
        address: '@',
        propertyId: '@',
        streetViewImageUrl: '@',
      },
      template: '<div class="property-header-thumbnail"></div>',
      link: function (scope, element, attrs) {
        var showImage = false
        if (scope.address == '19111 Pruneridge Ave, Cupertino, CA 95014') {
          element.append(
            '<img src="' +
              bzGlobal.applicationConstants.images.appleProperty +
              '">'
          )
          showImage = true
        } else if (scope.propertyId == '18052761') {
          element.append(
            '<img src="' +
              bzGlobal.applicationConstants.images.teslaProperty +
              '">'
          )
          showImage = true
        } else {
          googleMapsStreetViewService.getImage({
            width: 200,
            height: 200,
            latitude: scope.latitude,
            longitude: scope.longitude,
            successCallback: function (imageURL) {
              var streetViewImageUrl = scope.streetViewImageUrl
                ? scope.streetViewImageUrl
                : imageURL

              if (streetViewImageUrl) {
                element.append('<img src="' + streetViewImageUrl + '">')
                element.show()
              }
            },
            failureCallback: function () {
              //element.append('<img src="' + bzGlobal.urlConstants.s3.assetUrl + '_thumbnails/house_200.png">');
            },
          })
        }

        if (showImage) element.show()
      },
    }
  },
])
